import { useState } from 'react';

import { QuoteMode } from 'pages/QuoteView/Quoting/RequestQuickQuote/types';
import { Maybe, MaybeUndef } from 'types/UtilityTypes';
import { useThrowableSWR } from 'utils/fetcher';

export interface MGBAccessorialChargeSuggestion {
  accessorialCode: string;
  accessorialDescription?: string;
  qqName: string;
  chargeText: string;
  suggestedAmount: Maybe<number>;
  stopSide?: string;
}

type MGBAccessorialChargesResponse = {
  charges: MGBAccessorialChargeSuggestion[];
};

type FetchAccessorialChargesOptions = {
  customerName?: MaybeUndef<string>;
  quoteMode?: QuoteMode;
};

export function useFetchMGBAccessorialCharges(
  tmsID: number,
  options?: FetchAccessorialChargesOptions
) {
  const customerName = options?.customerName?.trim() ?? '';
  const quoteMode = options?.quoteMode ?? QuoteMode.TL;
  const [isRefreshing, setIsRefreshing] = useState(false);

  const key =
    !tmsID || !customerName
      ? null
      : `load/options/accessorial-charges?tmsID=${tmsID}&customerName=${encodeURIComponent(
          customerName
        )}&quoteMode=${quoteMode.toLowerCase()}`;

  const { data, error, isLoading, mutate } =
    useThrowableSWR<MGBAccessorialChargesResponse>(key, false);

  const refresh = async () => {
    setIsRefreshing(true);
    try {
      await mutate();
    } finally {
      setIsRefreshing(false);
    }
  };

  return {
    charges: data?.charges ?? [],
    isLoading: (Boolean(key) && isLoading) || isRefreshing,
    error,
    refresh,
  };
}
